// Generated by psc version 0.10.2
"use strict";
var Prelude = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Prelude.purs");
var Control_Comonad = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-control/src/Control/Comonad.purs");
var Control_Extend = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-control/src/Control/Extend.purs");
var Data_Functor_Invariant = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-invariant/src/Data/Functor/Invariant.purs");
var Data_Monoid = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-monoid/src/Data/Monoid.purs");
var Data_Newtype = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-newtype/src/Data/Newtype.purs");
var Data_Eq = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Eq.purs");
var Data_Ord = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Ord.purs");
var Data_Bounded = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Bounded.purs");
var Data_Functor = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Functor.purs");
var Control_Apply = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Apply.purs");
var Control_Applicative = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Applicative.purs");
var Control_Bind = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Bind.purs");
var Control_Monad = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Monad.purs");
var Data_Show = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Show.purs");
var Data_Semigroup = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Semigroup.purs");
var Data_Semiring = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Semiring.purs");
var Additive = function (x) {
    return x;
};
var showAdditive = function (dictShow) {
    return new Data_Show.Show(function (v) {
        return "(Additive " + (Data_Show.show(dictShow)(v) + ")");
    });
};
var semigroupAdditive = function (dictSemiring) {
    return new Data_Semigroup.Semigroup(function (v) {
        return function (v1) {
            return Data_Semiring.add(dictSemiring)(v)(v1);
        };
    });
};
var ordAdditive = function (dictOrd) {
    return dictOrd;
};
var newtypeAdditive = new Data_Newtype.Newtype(function (n) {
    return n;
}, Additive);
var monoidAdditive = function (dictSemiring) {
    return new Data_Monoid.Monoid(function () {
        return semigroupAdditive(dictSemiring);
    }, Data_Semiring.zero(dictSemiring));
};
var invariantAdditive = new Data_Functor_Invariant.Invariant(function (f) {
    return function (v) {
        return function (v1) {
            return f(v1);
        };
    };
});
var functorAdditive = new Data_Functor.Functor(function (f) {
    return function (v) {
        return f(v);
    };
});
var extendAdditive = new Control_Extend.Extend(function () {
    return functorAdditive;
}, function (f) {
    return function (x) {
        return f(x);
    };
});
var eqAdditive = function (dictEq) {
    return dictEq;
};
var comonadAdditive = new Control_Comonad.Comonad(function () {
    return extendAdditive;
}, Data_Newtype.unwrap(newtypeAdditive));
var boundedAdditive = function (dictBounded) {
    return dictBounded;
};
var applyAdditive = new Control_Apply.Apply(function () {
    return functorAdditive;
}, function (v) {
    return function (v1) {
        return v(v1);
    };
});
var bindAdditive = new Control_Bind.Bind(function () {
    return applyAdditive;
}, function (v) {
    return function (f) {
        return f(v);
    };
});
var applicativeAdditive = new Control_Applicative.Applicative(function () {
    return applyAdditive;
}, Additive);
var monadAdditive = new Control_Monad.Monad(function () {
    return applicativeAdditive;
}, function () {
    return bindAdditive;
});
module.exports = {
    Additive: Additive, 
    newtypeAdditive: newtypeAdditive, 
    eqAdditive: eqAdditive, 
    ordAdditive: ordAdditive, 
    boundedAdditive: boundedAdditive, 
    functorAdditive: functorAdditive, 
    invariantAdditive: invariantAdditive, 
    applyAdditive: applyAdditive, 
    applicativeAdditive: applicativeAdditive, 
    bindAdditive: bindAdditive, 
    monadAdditive: monadAdditive, 
    extendAdditive: extendAdditive, 
    comonadAdditive: comonadAdditive, 
    showAdditive: showAdditive, 
    semigroupAdditive: semigroupAdditive, 
    monoidAdditive: monoidAdditive
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-monoid/src/Data/Monoid/Additive.purs
// module id = 57
// module chunks = 0